const StdAnimations = {
    merge: function(name, otherProps) {
        let anim = StdAnimations[name];
        return { ...anim, ...otherProps };
    },
    appearingTitle:  { rotateX: '-30deg', scale: 0.8, opacity: 0, duration: 1, ease: 'back' },
    incrementNumber: { textContent: 0, duration: 4, snap: { textContent: 1 } },
    appearPop:       { opacity: 0, scale: 0.3, duration: 1, ease: 'back.out(3)' },
    appearSlide:     { clipPath: 'inset(0 0 100% 0)', opacity: 0.5, y: 20, duration: 1 },
}

export default StdAnimations;